import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const StatsCard = ({ title, value, unit, icon, color }) => {
  const colorMap = {
    indigo: 'bg-indigo-600 text-white shadow-indigo-100',
    emerald: 'bg-emerald-500 text-white shadow-emerald-100',
    amber: 'bg-amber-500 text-white shadow-amber-100',
    slate: 'bg-slate-800 text-white shadow-slate-100',
    white: 'bg-white text-slate-900 border border-slate-100 shadow-slate-50'
  };

  const iconColorMap = {
    indigo: 'bg-white/20 text-white',
    emerald: 'bg-white/20 text-white',
    amber: 'bg-white/20 text-white',
    slate: 'bg-white/20 text-white',
    white: 'bg-indigo-50 text-indigo-600'
  };

  return (
    <motion.div
      whileHover={{ y: -4, transition: { duration: 0.2 } }}
      className={`${colorMap[color] || colorMap.white} rounded-[32px] p-6 shadow-xl flex flex-col justify-between h-full min-w-[200px]`}
    >
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-2xl ${iconColorMap[color] || iconColorMap.white}`}>
          <SafeIcon icon={icon} className="text-xl" />
        </div>
      </div>
      
      <div>
        <div className="flex items-baseline gap-1">
          <h3 className="text-3xl font-black italic uppercase italic leading-none">{value}</h3>
          {unit && <span className="text-[10px] font-black uppercase opacity-60 italic">{unit}</span>}
        </div>
        <p className="text-[10px] font-black uppercase tracking-widest mt-2 opacity-80 italic">{title}</p>
      </div>
    </motion.div>
  );
};

export default StatsCard;